import type { AccountAnalyticsStats } from '../../types/accountAnalytics';

// Headline totals. The operational count (Locations & Dealerships — the book of
// business) is prominent; all-types + the distinct-dimension counts are the
// secondary row.
export function AnalyticsStatCards({ stats }: { stats: AccountAnalyticsStats }) {
  const cards: { label: string; value: number; primary?: boolean }[] = [
    { label: 'Locations & Dealerships', value: stats.totalOperational, primary: true },
    { label: 'All accounts', value: stats.totalAll },
    { label: 'Brands', value: stats.brands },
    { label: 'Groups', value: stats.groups },
    { label: 'Account managers', value: stats.accountManagers },
    { label: 'Industries', value: stats.industries },
  ];
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
      {cards.map((c) => (
        <div
          key={c.label}
          className={[
            'rounded-lg border bg-white p-4',
            c.primary ? 'border-kyck-300 ring-1 ring-kyck-100' : 'border-slate-200',
          ].join(' ')}
        >
          <div
            className={[
              'text-2xl font-semibold leading-tight',
              c.primary ? 'text-kyck-700' : 'text-slate-900',
            ].join(' ')}
          >
            {c.value.toLocaleString()}
          </div>
          <div className="mt-1 text-xs text-slate-500">{c.label}</div>
        </div>
      ))}
    </div>
  );
}
